import React from 'react';

import Image from 'next/image';

import { ModalCloseButtonWrapper } from './ModalCloseButton.style';
import { ModalCloseButtonProps } from './ModalCloseButton.types';

export const ModalCloseButton = ({ onClick }: ModalCloseButtonProps) => {
  return (
    <ModalCloseButtonWrapper onClick={onClick} aria-label="Close modal">
      <Image src="/assets/images/x-close.svg" alt="Close icon" width={24} height={24} />
    </ModalCloseButtonWrapper>
  );
};
